<div class="container" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px" fxLayoutGap.lt-sm="8px">
    <div
        class="header"
        fxLayout="row"
        fxLayout.lt-lg="column"
        fxLayoutAlign.gt-md="start center"
        fxLayoutGap="8px"
        fxLayoutAlign="start"
    >
        <div class="heading">TIMELINE</div>

        <custom-date-range
            (dateChanged)="customDateRangeChange($event)"
            [zoomLevel]="zoomLevel"
            [seekTime]="seekTime"
            [startTime]="startTime"
            [endTime]="endTime"
        >
        </custom-date-range>
    </div>

    <!-- Spacer -->
    <div fxFlex></div>

    <div
        fxLayout="row"
        fxLayout.xs="column-reverse"
        fxLayoutGap="8px"
        fxLayoutAlign="center center"
        class="actions-container"
    >
        <!-- seeking actions -->
        <div class="actions seek-actions" fxLayoutGap="6px">
            <button
                mat-icon-button
                matTooltip="{{ zoomLevel !== 'CUSTOM' ? 'Previous ' + zoomLevel.toLowerCase() : 'Previous range' }}"
                (click)="seek(-1)"
                (keydown.enter)="seek(-1)"
            >
                <mat-icon svgIcon="c-skip-back"></mat-icon>
            </button>
            <button
                mat-icon-button
                matTooltip="{{ zoomLevel !== 'CUSTOM' ? 'Next ' + zoomLevel.toLowerCase() : 'Next range' }}"
                (click)="seek(1)"
                (keydown.enter)="seek(1)"
                [disabled]="!canSeekForward"
            >
                <mat-icon svgIcon="c-skip-forward"></mat-icon>
            </button>
        </div>

        <!-- zoom actions -->
        <div class="actions zoom-actions" fxLayoutGap="6px">
            <button
                mat-icon-button
                matTooltip="Zoom in"
                (click)="zoomIn()"
                (keydown.enter)="zoomIn()"
                [disabled]="!canZoomIn"
            >
                <mat-icon svgIcon="c-zoom-in"></mat-icon>
            </button>
            <button
                mat-icon-button
                matTooltip="Zoom out"
                (click)="zoomOut()"
                (keydown.enter)="zoomOut()"
                [disabled]="!canZoomOut"
            >
                <mat-icon svgIcon="c-zoom-out"></mat-icon>
            </button>
            <button mat-icon-button matTooltip="Reset" (click)="zoomReset()" (keydown.enter)="zoomReset()">
                <mat-icon svgIcon="c-zoom-reset"></mat-icon>
            </button>
        </div>

        <!-- export power usage excel -->
        <div class="actions" *ngIf="!hideDownloadExcel">
            <button
                mat-icon-button
                matTooltip="Download as Excel"
                [disabled]="!canDownloadExcel"
                (click)="downloadExcel()"
                (keydown.enter)="downloadExcel()"
            >
                <mat-icon svgIcon="microsoft-excel"></mat-icon>
            </button>
        </div>
    </div>

    <div *ngIf="stationId">
        <button mat-icon-button (click)="openDialogClick()" (keydown.enter)="openDialogClick()">
            <mat-icon svgIcon="c-maximize"></mat-icon>
        </button>
    </div>
</div>
